import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalTitle } from 'react-bootstrap';
import {
  FacebookShareButton, LinkedinShareButton, TwitterShareButton,
  WhatsappShareButton, TelegramShareButton, EmailShareButton,
  EmailIcon, FacebookIcon, LinkedinIcon, TelegramIcon, TwitterIcon, WhatsappIcon
} from 'react-share';

const SocialShare = ({
  opened = false,
  title = "Partager",
  subtitle = "Partager sur...",
  shareLink = "#",
  shareMessage = "",
  onClosed
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyTextToClipboard = async (text) => {
    if ('clipboard' in navigator) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (err) {
        console.log(err);
        return false;
      }
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    }
  };

  const onCopyClicked = (copyText) => {
    copyTextToClipboard(copyText)
      .then((success) => {
        if (success) {
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 1500);
        }
      });
  };

  const url = shareLink || '';
  const message = shareMessage || '';

  return (
    <>
      <Modal
        show={opened}
        onHide={onClosed}
        centered
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" as="h5">
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {subtitle && subtitle !== "" && (
            <p className="text-muted m-0 p-2">{subtitle}</p>
          )}

          <div className="row g-3 mb-2 align-items-center justify-content-center">
            <div className="col-lg-4 text-center">
              <FacebookShareButton url={url} quote={message}>
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
            </div>
            <div className="col-lg-4 text-center">
              <TwitterShareButton url={url} title={message}>
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
            </div>
            <div className="col-lg-4 text-center">
              <LinkedinShareButton url={url} title={message}>
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
            <div className="col-lg-4 text-center">
              <WhatsappShareButton url={url} title={message}>
                <WhatsappIcon size={35} round={true} />
              </WhatsappShareButton>
            </div>
            <div className="col-lg-4 text-center">
              <TelegramShareButton url={url} title={message}>
                <TelegramIcon size={35} round={true} />
              </TelegramShareButton>
            </div>
            <div className="col-lg-4 text-center">
              <EmailShareButton url={url} subject={title} body={message}>
                <EmailIcon size={35} round={true} />
              </EmailShareButton>
            </div>
          </div>

          {isCopied && (
            <div className="mt-3">
              <small className="p-2 text-green fw-bold">
                * Copié dans le presse-papier !
              </small>
            </div>
          )}

          <div className="input-group my-3">
            <input
              value={url}
              readOnly
              type="text"
              className="form-control"
              aria-label="shareLink"
              aria-describedby="basic-addon1"
            />
            <span
              className="input-group-text cursor-hand"
              id="basic-addon1"
              onClick={() => onCopyClicked(url)}
            >
              <i className="bx bx-copy-alt"></i>
            </span>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

SocialShare.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  shareLink: PropTypes.string.isRequired,
  shareMessage: PropTypes.string,
  opened: PropTypes.bool,
  onClosed: PropTypes.func
};

export default SocialShare;
